/**
 * The external dependencies.
 */
import {Link} from 'react-router-dom';
/**
 * The internal dependencies.
 */
import Button from '../../components/general/button';

export default Button.withComponent(Link);



// WEBPACK FOOTER //
// ./src/components/home/navigation-item.js